import React from "react";
import { Navigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { BRAND } from "../mock";

export default function PortalShell({ allow, children }) {
  const { user, loading, logout } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-[#004030]">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.kind !== allow) {
    const to = user.kind === "student" ? "/portal/student" : user.kind === "teacher" ? "/portal/teacher" : "/admin";
    return <Navigate to={to} replace />;
  }
  return (
    <div className="min-h-screen bg-[#f4f8f6]">
      <header className="h-16 bg-[#004030] flex items-center justify-between px-5 md:px-8">
        <div className="flex items-center gap-3">
          <img src={BRAND.logo} alt="GDIH" className="h-9 bg-white/95 rounded p-0.5" />
          <span className="font-display font-bold text-white hidden sm:block">GDIH Elite Portal</span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-white/90 text-sm">{user.name}</span>
          <button onClick={logout} className="flex items-center gap-1.5 text-white/80 hover:text-[#e0c05a] text-sm"><LogOut size={16} /> Sign out</button>
        </div>
      </header>
      <main className="max-w-5xl mx-auto p-5 md:p-8">{children}</main>
    </div>
  );
}
